// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"899":"26cf25282ac7468d","966":"645308c29c2ea432"}[chunkId] + ".js";
};